import { Item } from '@skinsoft/types'
import { itemSelectors } from '@skinsoft/selectors'

export const byRealTimeLocation = (a: Item, b: Item) => {
    const aRealTimeLocation = itemSelectors.realTimeLocation(a as Item) || '';
    const bRealTimeLocation = itemSelectors.realTimeLocation(b as Item) || '';
    return bRealTimeLocation.localeCompare(aRealTimeLocation);
};
